"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeNotificationTypeMetaSchema = void 0;
exports.ChangeNotificationTypeMetaSchema = {
    "$id": "https://www.redbull.com/schemas/types/change-notifications.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ChangeNotificationTypeMeta",
    "description": "Meta schema for change notification definition",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^rrn:change-notifications:[a-zA-Z0-9-]+$"
        },
        "type": {
            "type": "string",
            "enum": [
                "rrn:types:change-notifications"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "examples": {
                    "type": "array",
                    "items": {
                        "type": "object"
                    }
                },
                "displayName": {
                    "type": "string",
                    "pattern": "^[A-Za-z0-9]+$"
                },
                "description": {
                    "type": "string"
                },
                "schema": {
                    "type": "object",
                    "properties": {
                        "properties": {
                            "description": "Those are the properties of the schema",
                            "type": "object",
                            "properties": {
                                "additionalProperties": true
                            }
                        }
                    },
                    "required": [
                        "properties"
                    ]
                }
            },
            "required": [
                "displayName",
                "schema"
            ]
        }
    },
    "required": [
        "id",
        "type",
        "attributes"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhbmdlLW5vdGlmaWNhdGlvbnMuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvdHlwZXMvY2hhbmdlLW5vdGlmaWNhdGlvbnMuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsZ0NBQWdDLEdBQUc7SUFDOUMsS0FBSyxFQUFFLHdFQUF3RTtJQUMvRSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSw0QkFBNEI7SUFDckMsYUFBYSxFQUFFLGdEQUFnRDtJQUMvRCxNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSwwQ0FBMEM7U0FDdEQ7UUFDRCxNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sZ0NBQWdDO2FBQ2pDO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixVQUFVLEVBQUU7b0JBQ1YsTUFBTSxFQUFFLE9BQU87b0JBQ2YsT0FBTyxFQUFFO3dCQUNQLE1BQU0sRUFBRSxRQUFRO3FCQUNqQjtpQkFDRjtnQkFDRCxhQUFhLEVBQUU7b0JBQ2IsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLFNBQVMsRUFBRSxnQkFBZ0I7aUJBQzVCO2dCQUNELGFBQWEsRUFBRTtvQkFDYixNQUFNLEVBQUUsUUFBUTtpQkFDakI7Z0JBQ0QsUUFBUSxFQUFFO29CQUNSLE1BQU0sRUFBRSxRQUFRO29CQUNoQixZQUFZLEVBQUU7d0JBQ1osWUFBWSxFQUFFOzRCQUNaLGFBQWEsRUFBRSx3Q0FBd0M7NEJBQ3ZELE1BQU0sRUFBRSxRQUFROzRCQUNoQixZQUFZLEVBQUU7Z0NBQ1osc0JBQXNCLEVBQUUsSUFBSTs2QkFDN0I7eUJBQ0Y7cUJBQ0Y7b0JBQ0QsVUFBVSxFQUFFO3dCQUNWLFlBQVk7cUJBQ2I7aUJBQ0Y7YUFDRjtZQUNELFVBQVUsRUFBRTtnQkFDVixhQUFhO2dCQUNiLFFBQVE7YUFDVDtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixJQUFJO1FBQ0osTUFBTTtRQUNOLFlBQVk7S0FDYjtDQUNGLENBQUEifQ==